var keys = {}

export function addKeyboardKey(e) {
    keys[e.key] = true
}

export function removeKeyboardKey(e) {
    delete keys[e.key]
}

export function clearKeyboardKeys() {
    keys = {}
}

export function isCtrlPress(e) {
    return keys['Control']
}
export function isCommand(e) {
    return keys['Meta']
}
export default keys;